module.exports = __webpack_public_path__ + "img/H-B-3-unload-connect-shadow.e091ff9c.png";